import { useMutation, useQueryClient } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/subsidy/base';

export const useCancelRefundRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (refundRequestUuid: string) =>
      await falconClient.patch(
        `${baseUrl}/refund_requests/${refundRequestUuid}/cancel`
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useResourceApprovalsIndex],
        type: 'all',
      });
      queryClient.invalidateQueries({
        queryKey: [clientKeys.useResourceApprovalShow],
      });
    },
  });
};
